import { AxiosError, AxiosInstance, AxiosResponse, isAxiosError } from 'axios';
import { LAYOUT_ERRORS_CODES } from 'core/constants/layout-error.constants';
import type { IAutoprospectionError, IMaintenanceError } from 'core/model/interfaces/error.interface';
import { setLayoutError } from 'core/store/layout';
import { dispatchAction } from 'core/store/store.utils';
import { getNavigate } from 'shared/utils/layout-errors.utils';

export type TLayoutErrorCode = keyof typeof LAYOUT_ERRORS_CODES;

const createLayoutErrorResInterceptor = (
  axiosClient: AxiosInstance,
  interceptorSuccess: (value: AxiosResponse<any>) => AxiosResponse<any>,
) => {
  const interceptorError = (error: AxiosError<IMaintenanceError | IAutoprospectionError>) => {
    if (
      !isAxiosError<AxiosError<IMaintenanceError | IAutoprospectionError>>(error) ||
      !Object.keys(LAYOUT_ERRORS_CODES).includes(error.response?.data?.error?.code as string)
    )
      return Promise.reject(error);

    const payload = error.response?.data.error ?? null;
    if (!payload?.code) return Promise.reject(error);

    const navigate = getNavigate();
    dispatchAction(setLayoutError(payload));

    if (navigate) {
      navigate(LAYOUT_ERRORS_CODES[payload?.code as TLayoutErrorCode].redirect);
      return Promise.reject(error);
    }
  };

  axiosClient.interceptors.response.use(interceptorSuccess, interceptorError);
};

export default createLayoutErrorResInterceptor;
